import { MEDIA_URL } from '@/constants/env';
import { fadeIn } from '@/constants/motions';
import Image from '@/ui/Image';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { motion } from 'framer-motion';

export default function HomeSliderBlock({ slides }) {
  const safeSlides = slides || [];
  return (
    <motion.section
      className="xl:px-4"
      initial="hidden"
      transition={fadeIn.transition}
      variants={fadeIn}
      viewport={fadeIn.viewport}
      whileInView="visible"
    >
      <div className="mx-auto max-w-[1440px]">
        <Splide
          options={{
            arrows: false,
            autoplay: true,
            interval: 3000,
            rewind: 'true',
            speed: 2000,
            type: 'fade',
            classes: {
              pagination: 'splide__pagination md:flex-col md:inset-0 md:!items-end',
            },
          }}
        >
          {safeSlides.map((slide, i) => {
            const url = slide?.image?.data?.attributes?.url || '';
            if (!url) return null;
            return (
              <SplideSlide
                key={i}
                className="w-screen-sm h-80 overflow-hidden md:h-96 lg:h-[80vh] xl:rounded-xl"
              >
                <Image
                  alt="Slide"
                  className="h-full w-full object-cover"
                  src={MEDIA_URL.concat(url)}
                />
                <div className="absolute inset-0 flex h-full w-full items-center justify-center bg-gradient-to-b from-black/10 to-primary-600">
                  <div className="text-center text-white">
                    <h1 className="text-3xl font-bold drop-shadow-lg lg:text-5xl">{slide.title}</h1>
                    <p className="mt-2 text-lg font-light drop-shadow-lg lg:mt-6 lg:text-2xl">
                      {slide.description}
                    </p>
                  </div>
                </div>
              </SplideSlide>
            );
          })}
        </Splide>
      </div>
    </motion.section>
  );
}
